import React from 'react';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import Loader from '../../../../components/Loader/Loader'

import WhyHostFormBlock5 from '../../../../components/siteadmin/WhyHostPageSettings/WhyHostFormBlock5/WhyHostFormBlock5'
import getWhyHostPageSettings from './getWhyHostPageSettings.graphql';
import { withQuery } from '../../../../hoc/withGraphql';

import s from './WhyHostBlock5.css';

const WhyHostBlock5 = (props) => {

    const { data: { loading, getWhyHostPage }, title } = props;
    if (loading) return <Loader type={"text"} />;

    let settingsCollection = {};
    const dynamicMap = {};

    const BLOCK5_ACTIVE_FIELDS = ['workTitleHeading', 'peaceTitle1', 'peaceContent1', 'peaceTitle2', 'peaceContent2'];
    getWhyHostPage?.forEach((item) => {
        settingsCollection[item.name] = item.value;

        if (BLOCK5_ACTIVE_FIELDS.includes(item.name)) {
            item.dynamicWhyHostInfoBlock?.forEach((dynItem) => {
                if (!dynamicMap[dynItem.language]) {
                    dynamicMap[dynItem.language] = { language: dynItem.language };
                }
                dynamicMap[dynItem.language][dynItem.name] = dynItem.value;
            });
        }
    });

    const dynamicValues = Object.values(dynamicMap);

    settingsCollection.dynamicWhyHostInfoBlock = dynamicValues.length > 0
        ? dynamicValues
        : [{
            language: 'en',
            workTitleHeading: settingsCollection.workTitleHeading,
            peaceTitle1: settingsCollection.peaceTitle1,
            peaceContent1: settingsCollection.peaceContent1,
            peaceTitle2: settingsCollection.peaceTitle2,
            peaceContent2: settingsCollection.peaceContent2,
        }];

    return <WhyHostFormBlock5 initialValues={settingsCollection} title={title} />;
}

WhyHostBlock5.defaultProps = {
    data: {
        loading: false
    }
};

export default compose(
    withStyles(s),
    withQuery(getWhyHostPageSettings, {
        options: {
            fetchPolicy: 'network-only',
            ssr: false
        }
    }),
)(WhyHostBlock5);